export enum RowModeControlType {
    AUTO = "auto",
    ALWAYS_EDIT = "alwaysEdit",
    MANUAL = "manual"
}
